// extracted by mini-css-extract-plugin
export default {"header":"Header_header__j4yiL","active":"Header_active__yxI1k"};